import styled from 'styled-components'

const CardContainer = styled.div(
  ({ cardColor }) => `
  display: flex;
  width: 100%;
  padding: 8px 8px 8px 16px;
  align-items: center;
  gap: 8px;
  flex: 1 0 1;
  border-radius: 8px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: var(--white, #fff);
  overflow: hidden;
  position: relative;

  &:before {
    width: 5px;
    height: 100%;
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    background: ${cardColor};
  }
`
)

const CardIcon = styled.div(
  ({ cardColor }) => `
  display: flex;
  width: 56px;
  height: 56px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: var(--card-color, ${cardColor});

  img {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
`
)

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

const CardTitle = styled.span`
  color: var(--gray-800, #1a202c);
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 158.333%;
`

const CardDescription = styled.span`
  color: var(--Light-Text-Primary, text-primary);
  font-feature-settings: 'liga' off, 'clig' off;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`

const Styles = {
  CardContainer,
  CardIcon,
  CardTitle,
  CardDescription,
  CardContent,
}

export default Styles
